import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';

import * as components from './';

class SettingsRoutes extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/settings" component={components.Settings} />
        {/*
        <Route
          exact
          path="/sessions/new"
          component={components.SessionEditContainer}
        />
        <Route
          exact
          path="/sessions/new/:clientId"
          component={components.SessionEditContainer}
        />
        <Route
          exact
          path="/sessions/edit/:id"
          component={components.SessionEditContainer}
        />
        <Route
          exact
          path="/sessions/:id"
          component={components.SessionDetailContainer}
        />
        */}
      </Switch>
    );
  }
}

export default SettingsRoutes;



// WEBPACK FOOTER //
// ./src/modules/settings/components/SettingsRoutes.js